import { SettingsIcon } from "@chakra-ui/icons";
import { VStack, Box } from "@chakra-ui/react";
import { DataSourceType } from "@syla/shared/types/models/DataSourceBase";
import { DataSourceWithNetworks } from "@syla/shared/types/responses/DataSourceWithNetworks";
import React, { ReactElement } from "react";
import { useFormContext } from "react-hook-form";
import { DataSourceInputType } from "../../../../helper/dataSource/DataSourceInputType";
import { CollapsibleSection } from "../../../CollapsibleSection";
import { ImportMethod } from "../panels/ImportMethodSelectionPanel";
import { AddDataSourceForm } from "../workflows/AddDataSourceWorkflow";
import { DataSourceNameField } from "./DataSourceNameField";
import { SyncFromDateField } from "./SyncFromDateField";

export function AdvancedOptions({
  dataSource,
  importMethod,
}: {
  dataSource: DataSourceWithNetworks;
  importMethod: ImportMethod;
}): React.ReactElement | null {
  const form = useFormContext<AddDataSourceForm>();

  if (dataSource.type === DataSourceType.Import) {
    return null;
  }

  // Don't show any options for Assisted File Import.
  if (
    importMethod === DataSourceInputType.Csv &&
    dataSource.fileImportStatus === "alpha"
  ) {
    return null;
  }

  // The custom name is already shown in the main form.
  if (importMethod === "Empty") {
    return null;
  }

  const inputs: ReactElement[] = [];

  // Custom wallet already has the custom name shown in the main form.
  if (dataSource.type !== DataSourceType.Custom) {
    inputs.push(
      <DataSourceNameField
        key="customName"
        name="customName"
        form={form}
        backgroundColor="white"
      />,
    );
  }

  if (importMethod === DataSourceInputType.Api) {
    inputs.push(
      <SyncFromDateField form={form} name="fromDate" key="syncFromDate" />,
    );
  }

  if (inputs.length === 0) {
    return null;
  }

  return (
    <Box w="full" borderColor="gray.300" borderTopWidth="1px" pt={6}>
      <CollapsibleSection icon={SettingsIcon} title="Advanced Settings">
        <VStack py={4} px={4} w="full" align="flex-start" spacing={4}>
          {inputs}
        </VStack>
      </CollapsibleSection>
    </Box>
  );
}
